/**
 * Standard Dropdown Menu enhancement.
 *
 * The dropdown is fully usable via CSS alone (:hover / :focus-within), so if
 * this script fails to load for any reason the menu still opens and closes
 * correctly with mouse and keyboard. This script layers on top to:
 *   - keep aria-expanded in sync for screen readers
 *   - make nested flyouts usable on touch devices (tap to open, tap again to follow the link)
 *   - close open menus on outside click / Escape
 *
 * Vanilla JS, no dependencies, no external libraries.
 */
(function () {
  const OPEN_CLASS = 'dropdown-menu__item--open';

  const getTrigger = (item) => item.querySelector(':scope > .dropdown-menu__link[aria-expanded]');

  function openItem(item) {
    if (!item) return;
    item.classList.add(OPEN_CLASS);
    const trigger = getTrigger(item);
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
  }

  function closeItem(item) {
    if (!item) return;
    item.classList.remove(OPEN_CLASS);
    const trigger = getTrigger(item);
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
  }

  function closeAllWithin(root) {
    root.querySelectorAll('.' + OPEN_CLASS).forEach(closeItem);
  }

  function initMenu(root) {
    if (root.dataset.dropdownEnhanced === 'true') return;
    root.dataset.dropdownEnhanced = 'true';

    root.querySelectorAll('.dropdown-menu__item--has-children').forEach((item) => {
      item.addEventListener('pointerenter', (event) => {
        if (event.pointerType === 'touch') return;
        openItem(item);
      });

      item.addEventListener('pointerleave', (event) => {
        if (event.pointerType === 'touch') return;
        closeItem(item);
      });

      item.addEventListener('focusin', () => openItem(item));

      item.addEventListener('focusout', (event) => {
        if (!item.contains(event.relatedTarget)) closeItem(item);
      });

      // Touch: first tap opens the flyout, second tap follows the link.
      const trigger = getTrigger(item);
      if (trigger) {
        trigger.addEventListener('click', (event) => {
          const isTouch = matchMedia('(hover: none)').matches;
          if (isTouch && !item.classList.contains(OPEN_CLASS)) {
            event.preventDefault();
            closeAllWithin(root);
            openItem(item);
          }
        });
      }
    });
  }

  function initAll() {
    document.querySelectorAll('.dropdown-menu').forEach(initMenu);
  }

  document.addEventListener('click', (event) => {
    document.querySelectorAll('.dropdown-menu').forEach((menu) => {
      if (!menu.contains(event.target) && !menu.previousElementSibling?.contains(event.target)) {
        closeAllWithin(menu);
      }
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      document.querySelectorAll('.dropdown-menu').forEach(closeAllWithin);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init after theme editor section re-renders.
  document.addEventListener('shopify:section:load', initAll);
})();